import useEnv from "hooks/useEnvironment";
import { useEffect } from "react";
import store from "utils/reduxStore";

const useDebug = () => {
  const env = useEnv();

  // Set dev variables
  useEffect(() => {
    if (env === "DEV") window.store = store;
  }, [env]);

  return env;
};

export default useDebug;
